import { useEffect, useMemo } from "react";
import ReactGA4 from "react-ga4";
import { useHistory } from "react-router-dom";
import { useGlobalAcf } from "../../../services/app-state";

const trackingConfig = {
    // Overarching tracking
    global: (google_analytics_id: string) => ({
        trackingId: google_analytics_id,
        gaOptions: { name: "globalTracking" },
    }),
};

export const GoogleAnalytics = () => {
    const history = useHistory();
    const [
        {
            general: { google_analytics_id },
        },
    ] = useGlobalAcf();

    const globalTracking = useMemo(() => trackingConfig.global(google_analytics_id), [
        google_analytics_id,
    ]);

    useEffect(() => {
        ReactGA4.initialize([globalTracking], { testMode: false });
    }, [globalTracking, google_analytics_id]);

    useEffect(() => {
        ReactGA4.send({
            hitType: "pageview",
            page: history.location.pathname,
            title: document.title,
        });
    }, [
        globalTracking.gaOptions.name,
        history.location.pathname,
    ]);

    return null;
};
